var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessionHistoryNavIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 2.66667H18.6667V0H16V2.66667H8V0H5.33333V2.66667H2.66667C1.196 2.66667 0 3.86267 0 5.33333V24C0 25.4707 1.196 26.6667 2.66667 26.6667H21.3333C22.804 26.6667 24 25.4707 24 24V5.33333C24 3.86267 22.804 2.66667 21.3333 2.66667ZM21.336 24H2.66667V8H21.3333L21.336 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 20.5518L18.2756 12.9425L16.3903 11.0571L10.6663 16.7811L7.60897 13.7238L5.72363 15.6091L10.6663 20.5518Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionHistoryNavIconWhite);
export default __webpack_public_path__ + "static/media/session_history_nav_icon_white.0f202e5efb2b73b81c9ab0dc55a96d6e.svg";
export { ForwardRef as ReactComponent };